import { render } from "./LeadAdmin.vue?vue&type=template&id=525be5b0"
import script from "./LeadAdmin.vue?vue&type=script&lang=js"
export * from "./LeadAdmin.vue?vue&type=script&lang=js"

import "./LeadAdmin.vue?vue&type=style&index=0&id=525be5b0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__